import { render } from "./DataScopeSettings.vue?vue&type=template&id=4177fecf&scoped=true"
import script from "./DataScopeSettings.vue?vue&type=script&lang=js"
export * from "./DataScopeSettings.vue?vue&type=script&lang=js"

import "./DataScopeSettings.vue?vue&type=style&index=0&id=4177fecf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4177fecf"]])

export default __exports__